---
title: Contact Us
description: Contacts page for ShipRapid
seo:
    title: Contact Us
    description: Contacts page for ShipRapid by L13o S.r.l
---

## Useful Links

- [FAQ](/#faq)
- [Terms of Service](/tos)
- [Privacy Policy](/privacy/policy)
- [Refund Policy](/refunds)

## Company Information

*ShipRapid* is a product of **L13o S.R.L**, a company based in Italy.

If you have any questions, doubts, or feedback, please contact us at the following addresses:
- for legal matters at [hello@l13o.com](mailto:hello@l13o.com)
- for anything else about this product at [hello@shiprap.id](mailto:hello@shiprap.id)

If you are a customer, please use the same email address that you used to purchase *ShipRapid*.

More information about our company can be found on our website: [https://l13o.com/manifesto](https://l13o.com/manifesto)